import { deleteParrotLab, deleteVSCode, destroyStarshipLab } from '../api/Lab-Service'

export async function launchLab(navigate, labData, isSubscription = false) {
  localStorage.setItem('startingLabData', JSON.stringify(labData))
  if (isSubscription) return navigate('/subscription/lab-loading')
  return navigate(`/regular/lab-loading`)
}

export async function destroyLab({
  navigate,
  payloadForDestroyLab,
  labGroupID,
  moduleID,
  isSubscription = false,
}) {
  const isTaskStored = Boolean(localStorage.getItem('task_id'))

  try {
    await deleteParrotLab()
  } catch (error) {
    // error code
  }
  try {
    await deleteVSCode()
  } catch (error) {
    // error code
  }
  if (!payloadForDestroyLab) {
    if (isTaskStored) {
      const payload = { task_id: localStorage.getItem('task_id') }

      try {
        localStorage.removeItem('task_id')
        await destroyStarshipLab(payload)
      } catch (err) {
        console.error(err)
      }
    } else return
  } else {
    try {
      await destroyStarshipLab(payloadForDestroyLab)
      cleanupLocalStorage()
      if (isSubscription) return navigate(`/subscription`)
      return navigate(`/lab-group-modules/${labGroupID}/${moduleID}`)
    } catch (err) {
      console.error(err)
    }
  }
}

export const cleanupLocalStorage = (keysToKeep = ['access_token']) => {
  Object.keys(localStorage).forEach((key) => {
    if (!keysToKeep.includes(key)) {
      localStorage.removeItem(key)
    }
  })
}

// Utility functions
export const formatDuration = (count, singleDuration) => {
  const totalMinutes = count * singleDuration
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  if (hours === 0) {
    return `${minutes || 0} min`
  } else if (minutes === 0) {
    return `${hours || 0} hr${hours > 1 ? 's' : ''}`
  } else {
    return hours ? `${hours || 0} hr${hours > 1 ? 's' : ''}+` : `${minutes || 0} min`
  }
}

export const getLocalStorageData = (key) => {
  try {
    const data = localStorage.getItem(key)
    return data ? JSON.parse(data) : null
  } catch (error) {
    console.error(`Error parsing localStorage data for key ${key}:`, error)
    return null
  }
}
